import React from 'react'

import { resize } from "./staleUploadImgFunctions"



export class ScaleUploadImg extends React.Component {

  state = {
      dataUrl: null
  }


  _onChange = (e) => {
      var files = e.target.files;
      var self = this;
      var maxWidth = this.props.maxWidth;
      var maxHeight = this.props.maxHeight;
      resize(files[0], maxWidth, maxHeight, function (resizedDataUrl) {
        self.props.onChangePhoto( resizedDataUrl )
      });
  }

  render() {
      return <div>
          <input ref="upload" type="file" accept="image/*" onChange={ this._onChange }/>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/ScaleUploadImg.js